import { render, staticRenderFns } from "./channelFans.vue?vue&type=template&id=185d7ba2&scoped=true&"
import script from "./channelFans.vue?vue&type=script&lang=js&"
export * from "./channelFans.vue?vue&type=script&lang=js&"
import style0 from "./channelFans.vue?vue&type=style&index=0&id=185d7ba2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d7ba2",
  null
  
)

export default component.exports